import { useTranslation } from '@mint-lib/i18n';
import { Leaf } from '@mint-lib/icons';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
  DrawerTrigger,
} from '@mint-lib/tw-components';

import { TabButton } from '../TabButton.jsx';

export const CarbonOffsetDrawer = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <TabButton
          Icon={Leaf}
          tooltip={t('Carbon Offset')}
          aria-label="Open carbon offset drawer"
          disabled
        />
      </DrawerTrigger>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerRoot>
          <DrawerHeader>
            <DrawerTitle>{t('Carbon Offset')}</DrawerTitle>
          </DrawerHeader>
          <DrawerContent>{t('Carbon Offset')}</DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
    </Drawer>
  );
};
